import { useTranslation } from 'react-i18next'
import { ErrorPage } from '../ErrorPage'

export const NotFoundPage = () => {
  const { t } = useTranslation()

  return (
    <ErrorPage
      description={t('notFoundPage.description')}
      title={t('notFoundPage.title')}
    />
  )
}
